import { IKraviaInvoiceHistory } from '@query'
import { Badge, TextTooltip } from '@components'
import { FaCheckCircle, FaQuestionCircle } from 'react-icons/fa'
import { KraviaActivityStatus } from '@constants'
import { useTranslation } from 'react-i18next'

interface Props {
  item: IKraviaInvoiceHistory
}

export const DebtCollectionStatusBadge: React.FC<Props> = ({ item }) => {
  const { t } = useTranslation()

  switch (item?.status) {
    case KraviaActivityStatus.WAITING_FOR_APPROVAL:
      return (
        <Badge type="error">
          {t('invoicing.debtCollection.kraviaStatus.waitingForApproval')}
          <TextTooltip tooltip={t('invoicing.debtCollection.kraviaStatus.waitingForApprovalInfo')}>
            <FaQuestionCircle />
          </TextTooltip>
        </Badge>
      )
    case KraviaActivityStatus.SCHEDULED:
      return <Badge type="default">{t('invoicing.debtCollection.kraviaStatus.scheduled')}</Badge>
    case KraviaActivityStatus.STARTED:
      return <Badge type="default">{t('invoicing.debtCollection.kraviaStatus.started')}</Badge>
    case KraviaActivityStatus.CANCELED:
      return <Badge type="default">{t('invoicing.debtCollection.kraviaStatus.canceled')}</Badge>
    case KraviaActivityStatus.COMPLETED:
      return (
        <Badge type="success">
          <FaCheckCircle />
          {t('invoicing.debtCollection.kraviaStatus.completed')}
        </Badge>
      )
    default:
      return null
  }
}
